import { DbKeyType, addIDB, getAllIDB, getByIdIDB, removeByIdIDB } from './helpers';

export const useIndexedDB = (dbKey: DbKeyType) => {
  const add = async (id: string, data: Record<string, unknown>) => addIDB(dbKey, id, data);
  const removeById = async (id: string) => removeByIdIDB(dbKey, id);
  const getById = async (id: string) => getByIdIDB(dbKey, id);
  const getAll = async () => getAllIDB(dbKey);

  return { add, removeById, getById, getAll };
};
